/* eslint-disable import/no-anonymous-default-export */
import {
    GET_ALL_PRODUCT_REVIEWS_PAGE,
    GET_PRODUCT_REVIEW_COUNT,
    GET_PRODUCT_REVIEW_COUNT_ERROR,
    GET_ALL_PRODUCT_REVIEWS_PAGE_ERROR,
    SELECT_PRODUCT_REVIEW,
    SEARCH_PRODUCT_REVIEWS,
    SEARCH_PRODUCT_REVIEWS_ERROR,
    UPDATE_PRODUCT_REVIEW,
    DELETE_PRODUCT_REVIEW,
    ADD_PRODUCT_REVIEW,
    GET_PRODUCT_REVIEWS,
    SET_FEATURED_REVIEW,
    SET_FEATURED_REVIEWS_FALSE,
    GET_FEATURED_REVIEW,
    GET_PRODUCT_REVIEWS_ERROR,
    SET_FEATURED_REVIEW_ERROR,
    SET_FEATURED_REVIEWS_FALSE_ERROR,
    GET_FEATURED_REVIEW_ERROR,
    UPDATE_PRODUCT_REVIEW_ERROR,
    DELETE_PRODUCT_REVIEW_ERROR,
    ADD_PRODUCT_REVIEW_ERROR,
    GET_PRODUCT_REVIEWS_BY_MANUFACTURER_ID_PAGE,
    GET_PRODUCT_REVIEWS_BY_MANUFACTURER_ID_PAGE_ERROR,
    SET_PRODUCT_REVIEWS_LIST_IS_LOADING_TRUE,
    GET_SEARCH_PRODUCT_REVIEW_COUNT,
    GET_SEARCH_PRODUCT_REVIEW_COUNT_ERROR,
    REMOVE_HOME_PAGE_FEATURED_USER_REVIEW,
    REMOVE_HOME_PAGE_FEATURED_USER_REVIEW_ERROR,
} from "../actions/types";

const initialState = {
    productReviews: [],
    
    featuredReview: [],
    // review: null,
    
    product: null,
    selectedProductReview: null,
    filteredProductReviews: [],
    filteredProductReviewsCount: null,
    isLoading: true,
    success: false,
    count: null,



    isLoadingProductReviewsList: true,
    productReviewsPaginated: [],
    productReviewCount: null,
    productReviewSearchPaginated: [],
    productReviewSearchCount: null,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {


        case SET_PRODUCT_REVIEWS_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingProductReviewsList: true,
            };
        case GET_ALL_PRODUCT_REVIEWS_PAGE:
            return {
                ...state,
                productReviewsPaginated: payload,
                isLoadingProductReviewsList: false,
                success: true,
            };
        case GET_ALL_PRODUCT_REVIEWS_PAGE_ERROR:
            return {
                ...state,
                productReviewsPaginated: payload,
                isLoadingProductReviewsList: false,
                success: false,
            };
        case GET_PRODUCT_REVIEW_COUNT:
            return {
                ...state,
                productReviewCount: payload,
                success: true,
            };
        case GET_PRODUCT_REVIEW_COUNT_ERROR:
            return {
                ...state,
                productReviewCount: payload,
                success: false,
            };
        case SEARCH_PRODUCT_REVIEWS:
            return {
                ...state,
                productReviewSearchPaginated: payload,
                isLoadingProductReviewsList: false,
                success: true,
            };
        case SEARCH_PRODUCT_REVIEWS_ERROR:
            return {
                ...state,
                productReviewSearchPaginated: payload,
                isLoadingProductReviewsList: false,
                success: false,
            };
        case GET_SEARCH_PRODUCT_REVIEW_COUNT:
            return {
                ...state,
                productReviewSearchCount: payload,
                success: true,
            };
        case GET_SEARCH_PRODUCT_REVIEW_COUNT_ERROR:
            return {
                ...state,
                productReviewSearchCount: payload,
                success: false,
            };






        case GET_PRODUCT_REVIEWS_BY_MANUFACTURER_ID_PAGE:
            return {
                ...state,
                filteredProductReviews: payload.rows,
                filteredProductReviewsCount: payload.count,
                isLoading: false,
                success: true,
            };
       
        case GET_PRODUCT_REVIEWS:
            return {
                ...state,
                productReviews: payload,
                isLoading: false,
                success: true,
            };
        case GET_FEATURED_REVIEW:
            return {
                ...state,
                featuredReview: payload,
                isLoading: false,
                success: true,
            };
        
        case SELECT_PRODUCT_REVIEW:
            return {
                ...state,
                selectedProductReview: payload,
            };
        
        case SET_FEATURED_REVIEWS_FALSE:
        case SET_FEATURED_REVIEW:
        case UPDATE_PRODUCT_REVIEW:
        case DELETE_PRODUCT_REVIEW:
        case ADD_PRODUCT_REVIEW:
        case REMOVE_HOME_PAGE_FEATURED_USER_REVIEW:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        
        case GET_PRODUCT_REVIEWS_ERROR:
            return {
                ...state,
                productReviews: payload,
                isLoading: false,
                success: false,
            };

        
        case SET_FEATURED_REVIEWS_FALSE_ERROR:
        case SET_FEATURED_REVIEW_ERROR:
        case UPDATE_PRODUCT_REVIEW_ERROR:
        case DELETE_PRODUCT_REVIEW_ERROR:
        case ADD_PRODUCT_REVIEW_ERROR:
        case GET_PRODUCT_REVIEWS_BY_MANUFACTURER_ID_PAGE_ERROR:
        case REMOVE_HOME_PAGE_FEATURED_USER_REVIEW_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        case GET_FEATURED_REVIEW_ERROR:
            return {
                ...state,
                featuredReview: payload,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
